(function (Drupal) {
  Drupal.behaviors.createTabsFromAccordion = {
    attach: function (context, settings) {
      // Seleccionar el elemento con la clase 'tabs-additional-information'
      const tabsContainer = document.querySelector('.tabs-additional-information', context);
      if (tabsContainer) {
        // Seleccionar la lista de elementos 'tabs-additional-information__list'
        const tabsList = tabsContainer.querySelector('.tabs-additional-information__list');

        if (tabsList) {
          // Seleccionar todos los elementos 'field__item'
          const fieldItems = tabsList.querySelectorAll('.field__item');

          if (fieldItems.length > 0) {
            // Crear un contenedor para las pestañas
            const tabsNav = document.createElement('ul');
            tabsNav.className = 'tabs-nav';

            // Crear un contenedor para el contenido de las pestañas
            const tabsContent = document.createElement('div');
            tabsContent.className = 'tabs-content';

            fieldItems.forEach((item, index) => {
              // Seleccionar el título y el cuerpo del acordeón
              const accordionItem = item.querySelector('.accordion-item');
              const accordionCollapse = item.querySelector('.accordion-collapse');

              if (accordionItem && accordionCollapse) {
                // Crear el elemento de la pestaña
                const tab = document.createElement('li');
                tab.className = 'tab';
                tab.innerText = accordionItem.innerText;
                tab.setAttribute('data-tab', `tab-${index}`);
                
                // Añadir el evento click para mostrar la pestaña correspondiente
                tab.addEventListener('click', function() {
                  document.querySelectorAll('.tab, .tab-content').forEach(el => el.classList.remove('active'));
                  tab.classList.add('active');
                  document.querySelector(`.tab-content[data-tab="tab-${index}"]`).classList.add('active');
                });
                // Crear el contenedor del contenido de la pestaña
                const tabContent = document.createElement('div');
                tabContent.className = 'tab-content';
                tabContent.setAttribute('data-tab', `tab-${index}`);
                tabContent.innerHTML = accordionCollapse.innerHTML;

                // Añadir la pestaña y el contenido de la pestaña a sus respectivos contenedores
                tabsNav.appendChild(tab);
                tabsContent.appendChild(tabContent);

                // Ocultar el acordeón original
                item.style.display = 'none';
              }
            });

            // Añadir las pestañas y el contenido de las pestañas al contenedor principal
            tabsContainer.appendChild(tabsNav);
            tabsContainer.appendChild(tabsContent);

            // Activar la primera pestaña por defecto
            if (tabsNav.firstChild && tabsContent.firstChild) {
              tabsNav.firstChild.classList.add('active');
              tabsContent.firstChild.classList.add('active');
            }
          }
        }
      }
    }
  };
})(Drupal);
